import { defineMessages } from 'react-intl';

export default defineMessages({
    VehicleModifiedLabel: {
        id: 'qnb.spm.vehiclePage.yourCar.VehicleModifiedLabel',
        defaultMessage: 'Has your {vehicle} been modified since it was sold as new?'
    },
    EditModificationButton: {
        id: 'qnb.spm.vehiclePage.yourCar.modification.EditModificationButton',
        defaultMessage: 'Edit'
    },
    RemoveModificationButton: {
        id: 'qnb.spm.vehiclePage.yourCar.modification.RemoveModificationButton',
        defaultMessage: 'Remove'
    },
    HowIsCarModifiedLabel: {
        id: 'qnb.spm.vehiclePage.yourCar.HowIsCarModifiedLabel',
        defaultMessage: 'How has the {vehicle} been modified?'
    },
    ModificationCategoryLabel: {
        id: 'qnb.spm.vehiclePage.yourCar.modification.ModificationCategoryLabel',
        defaultMessage: 'Category'
    },
    ModificationTypeLabel: {
        id: 'qnb.spm.vehiclePage.yourCar.modification.ModificationTypeLabel',
        defaultMessage: 'Type'
    },
    NormalFootControlLabel: {
        id: 'qnb.spm.vehiclePage.yourCar.modification.NormalFootControlLabel',
        defaultMessage: 'Can the {vehicle} be driven with normal foot controls as well?'
    },
    DisabledDriverLabel: {
        id: 'qnb.spm.vehiclePage.yourCar.modification.DisabledDriverLabel',
        defaultMessage: 'Which driver has the modification been made for?'
    },
    LowPerfIncreaseLabel: {
        id: 'qnb.spm.vehiclePage.yourCar.modification.LowPerfIncreaseLabel',
        defaultMessage: 'Is the increase in performance less than 10%?'
    },
    TowingPerformanceLabel: {
        id: 'qnb.spm.vehiclePage.yourCar.modification.TowingPerformanceLabel',
        defaultMessage: 'Has the alteration been made to improve the {vehicle}\'s towing performance?'
    },
    BodykitConversionLabel: {
        id: 'qnb.spm.vehiclePage.yourCar.modification.BodykitConversionLabel',
        defaultMessage: 'Has there been a bodykit conversion on the vehicle?'
    },
    SleepingCookingFacilitiesLabel: {
        id: 'qnb.spm.vehiclePage.yourCar.modification.SleepingCookingFacilitiesLabel',
        defaultMessage: 'Are sleeping and cooking facilities fitted?'
    },
    ModificationCostLabel: {
        id: 'qnb.spm.vehiclePage.yourCar.modification.ModificationCostLabel',
        defaultMessage: 'How much did it cost?'
    },
    ModificationCostHelp: {
        id: 'qnb.spm.vehiclePage.yourCar.modification.ModificationCostHelp',
        defaultMessage: 'If you are not sure, please give an approximate cost.'
    },
    SaveModificationButtonContent: {
        id: 'qnb.spm.vehiclePage.yourCar.modification.saveModificationButton',
        defaultMessage: 'Save Modification'
    },
    CancelModificationButtonContent: {
        id: 'qnb.spm.vehiclePage.yourCar.modification.cancelModificationButton',
        defaultMessage: 'Cancel'
    },
    ModificationValidationMessage: {
        id: 'qnb.spm.vehiclePage.yourCar.modification.modificationValidationMessage',
        defaultMessage: 'Please save your modification.'
    },
});
